import React, { useEffect, useRef } from 'react';
import styles from './miss-match.module.scss';
import { Typography } from '@/ui-kit';
import { useAuth } from '@/store/useAuth';
import { routesApp } from '@/constans/routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
    onAnimFinished: () => void
}

export const MissMatch: React.FC<Props> = ({ onAnimFinished }) => {
    const rootEl = useRef<HTMLDivElement>(null)
    const userData = useAuth((state) => state.getUser());
    
    const onInit = async () => {
        if (rootEl.current) {
            await Promise.all(
                rootEl
                    .current
                    ?.getAnimations()
                    .map(e => e.finished)
                    ?? []
            )
            onAnimFinished()
        }
    }

    useEffect(() => {
        onInit()
    }, [rootEl])

    const navigate = useNavigate();

    const { t } = useTranslation();

    return (
        <div
            ref={rootEl}
            className={styles.wrapper}
            onClick={() => navigate(routesApp.subscription)}>
            <div className={styles.icon} />
            <div className={styles.aside}>
                <Typography
                    typeColor="white"
                    fontWeight="semibold"
                    variant="h6">
                    {
                        t(
                            'browse.match_miss',
                            {
                                miss: t(
                                    'browse.miss',
                                    { context: userData?.gender }
                                )
                            }
                        )
                    }
                </Typography>
                <Typography typeColor="white">
                    {t('browse.activate_premium')}
                </Typography>
            </div>
        </div>
    );
};
